import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { GetAccess } from '../../../../Components/Utils/roles';
import SearchBar from '../../../../Components/Utils/SearchBar';
import { BackButton, ClearFilterButton, CreateButton, EditButton, ExportButton, FilterButton, ImportButton } from '../../../../Components/Utils/Buttons';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';



const FireExtiguisherLayout =({
    getData = () => {},
    setSearchQuery = () => {},
    CreateAccess = false,
    ImportAccess = false,
    setOpen = () => {},
    setOpenExport = () => {},
    children,
    onCreateClick,
    searchValue = "",
    searchFun = () => {},
    isFilter = false,
    setFilterOpen = () => {},
    newfilter = false,
    ClearFilter = () => {},
    neededSearch = false,
    showproject = true,
    isCard = true,
    setViewMode = () => {},
    viewMode = "",
    ExportAccess = false,
    BackButtonAccess=false,
    EditBttonAccess=false,
  }) => {
    let { pathname } = useLocation();
    const [module, setModule] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    const pageIndex = location.state?.pageIndex;
    const searchQuery = location.state?.searchQuery;
    const { fireExtinguishersViewId } = useParams();
    const data = location.state?.data;
    const from = location.state?.from || -1; 

  console.log("from",from);
    const [screenSize, setScreenSize] = useState({
      width: window.innerWidth,
    });
  
    useEffect(() => {
      const handleResize = () => {
        setScreenSize({
          width: window.innerWidth,
        });
      };
  
      window.addEventListener("resize", handleResize);
  
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);
  
    useEffect(() => {
       if (pathname == `/Contract-management/fireExtinguisher/view/${fireExtinguishersViewId}`) {
         setModule("Details");
       } else if (pathname == `/Contract-management/fireExtinguisher/form/${fireExtinguishersViewId}`) {
         setModule("Form");
       }
       else if (pathname == `/Contract-management/fireExtinguisher/equipments/${fireExtinguishersViewId}`) {
        setModule("Equipments");
      }
       
     }, [pathname]);
   
     let LinkItem = [
       {
         label: "Details",
         link: `/Contract-management/fireExtinguisher/view/${fireExtinguishersViewId}`,
         access: true,
       },
       {
         label: "Fire-Extinguisher Form",

         link: `/Contract-management/fireExtinguisher/form/${fireExtinguishersViewId}`,
         access: GetAccess('fire_suppression_form_view'),
       },
      //  {
      //   label: "Equipments",

      //   link: `/Contract-management/fireExtinguisher/equipments/${fireExtinguishersViewId}`,
      //   access: GetAccess(),
      // },
     ];
   
  
    return (
      <div className=" w-full   h-full py-2 px-2 md:overflow-hidden">
        <div className="md:flex justify-between w-full  ">
        <div className="md:flex justify-between w-full px-2">
        <Breadcrumb
          items={[
            
            
            {
              name: "Fire Extinguisher",
              link:"/Contract-management/fireExtinguisher"
            },

            { name: module },
          ]}
        />
          <div className=" flex justify-end gap-2 ">
             {BackButtonAccess&&( 
                    //  <Link
                    //   to={`/Contract-management/fireExtinguisher`}
                    //   state={{
                    //     currentPage: pageIndex,
                    //     searchQuery: searchQuery != "" ? searchQuery : "",
                    //   }}
                    // >
                        
                    //   <BackButton  />
                    // </Link>


                      <BackButton
                                                                      link={true}
                                                                      hasLink={
                                                                        module !== "Details"
                                                                          ? `/Contract-management/fireExtinguisher`
                                                                          : `/Contract-management/fireExtinguisher`
                                                                      }
                                                                      state={
                                                                        module === "Details"
                                                                          ? {
                                                                              currentPage: pageIndex,
                                                                              searchQuery: searchQuery !== "" ? searchQuery : "",
                                                                            }
                                                                          : null
                                                                      }
                                                                    />
                )}
            {EditBttonAccess&&(   
                  <Link
                      to={`/Contract-management/fireExtinguisher/edit/${fireExtinguishersViewId}`}
                      state={{
                        data: data,
                        from: `/Contract-management/fireExtinguisher/view/${fireExtinguishersViewId}`,
                      }}
                    >
                      <EditButton height="8" />
                    </Link>
               )}
               
               
                  </div>
        </div>
         
  
        
           
        </div>
        <div className=" w-full  flex items-center gap-x-1 ml-2">
            {LinkItem &&
              LinkItem.map((item, i) => { 
                const isActive = item?.link === pathname;
                return (
                  <>
                    {item.access && (
                      <Link
                      to={item?.link}
                      key={item?.link}
                      className={`px-4 py-1 rounded-t-md text-xs 2xl:text-sm font-medium mt-0.5
                        ${isActive 
                          ? "bg-baseColor-primary text-white" 
                          : "bg-white text-baseColor-primary border-b-2 border-baseColor-primary"
                        }`}
                    >
                      {item?.label || ""}
                      </Link>
                    )}
                  </>
                );
              })}
          </div>
  
        <div className=" w-full h-[calc(100vh-180px)]  md:h-[calc(100vh-160px)]  ">{children}</div>
      </div>
    );
  };
  

export default FireExtiguisherLayout